<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ErpTreeStatus from "./erp-tree-status";

export default {
  name: "HouseLayout",
  components: {ErpTreeStatus},
  methods:{
    nodeClick(data){
      this.$emit("nodeClick",data);
    },
  }
}
</script>

<style lang="scss" scoped>
//@import url(../common.scss);
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/HouseLayout.vue